export default __webpack_public_path__ + "images/pages/quiz/arrow-left-25923597e1fd732d8e5e11fcc9b870b4.svg";